module.exports = __webpack_public_path__ + "img/ajoutStockExemple1.6aacffca.png";